import { importTypeApi } from "../../api";

const ImportTypeService = {
  fetchDropdown: async () => {
    const response = await importTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default ImportTypeService;
